var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-modal",
    {
      attrs: { size: "tiny", closable: false },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c("sui-modal-header", { staticClass: "delete-alert-modal-header" }, [
        _vm._v(" Delete " + _vm._s(_vm.recordName) + " "),
      ]),
      _c("sui-modal-content", [
        _c("p", [
          _vm._v(
            "Are you sure you want to delete " + _vm._s(_vm.recordName) + "?"
          ),
        ]),
      ]),
      _c(
        "sui-modal-actions",
        [
          _c("sui-button", {
            attrs: {
              basic: "",
              size: "small",
              type: "button",
              content: "Cancel",
            },
            on: { click: _vm.handleCancel },
          }),
          _c("sui-button", {
            attrs: {
              primary: "",
              size: "small",
              type: "button",
              content: "Delete",
            },
            on: { click: _vm.handleDelete },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }